﻿package com.mgacreative.hotelru.feature.channelmanager.di

import com.mgacreative.hotelru.feature.channelmanager.domain.ChannelManagerService
import com.mgacreative.hotelru.feature.channelmanager.ui.ChannelManagerViewModel
import com.mgacreative.hotelru.feature.channelmanager.ui.AgencyAllotmentViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getChannelManagerFeatureModule() = module {
    single { ChannelManagerService() }
    viewModel { ChannelManagerViewModel(get()) }
    viewModel { AgencyAllotmentViewModel(get()) }
}

